//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    id: number;
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api/competition/{id} -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    result: t.union([
        t.null,
        t.undefined,
        t.interface({
            active: t.boolean,
            display: t.boolean,
            displayOrder: t.number,
            id: t.number,
            idv2: t.string,
            inPlayDelay: t.union([t.null, t.undefined, t.number]),
            name: t.string,
            sport: t.string,
            updatedAt: t.string,
        }),
    ]),
});
export type Response200Type = {
    result?:
        | null
        | undefined
        | {
              active: boolean;
              display: boolean;
              displayOrder: number;
              id: number;
              idv2: string;
              inPlayDelay?: null | undefined | number;
              name: string;
              sport: string;
              updatedAt: string;
          };
};
export const decodeResponse200 = createGuard(200, Response200IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiSocketGetCompetitionRequest"
 */
export const openapi_socket_get_competition = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api/competition/${params.id}${query}`;

    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiSocketGetCompetitionParamsType = ParamsType;

export type OpenapiSocketGetCompetitionResponseType = {
    status: 200;
    body: Response200Type;
};

export type OpenapiSocketGetCompetitionResponse200Type = Response200Type;

export const openapiSocketGetCompetitionRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiSocketGetCompetitionResponseType> => {
    const response = await openapi_socket_get_competition(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    throw new Error(`openapiSocketGetCompetitionRequest - unhandled response ${response.status}`);
};
